module.exports = __webpack_public_path__ + "img/5d31e2a2bf016169bb127061b5c44e79.png";